const LineFull = () => {
	return <div className='line-full'></div>
}

export default LineFull
